import {Drawer} from "antd";
import {ElectionIncidence} from "../lib/types";
import VideoPlayer from "./VidoePlayer";

type Props = {
    onClose: () => void;
    open: boolean;
    incidence: ElectionIncidence
}

export const IncidenceDetails = ({onClose, open, incidence}: Props) => {
    return (
        <Drawer title="Incidence Details" width={500} onClose={onClose} open={open} destroyOnClose={true} maskClosable={true}>
                    <div className="p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">
                            Election Incidence Details
                        </h2>

                        {/* Location Section */}
                        <div className="mb-6">
                            <h3 className="text-lg font-semibold text-gray-700">Location</h3>
                            <p>
                                <span className="font-medium">Constituency:</span> {incidence.constituency}
                            </p>
                            <p>
                                <span className="font-medium">Region:</span> {incidence.region}
                            </p>
                            <p>
                                <span className="font-medium">GPS:</span> {incidence.gps.latitude},{" "}
                                {incidence.gps.longitude}
                            </p>
                        </div>

                        {/* Incidence Details Section */}
                        <div className="mb-6">
                            <h3 className="text-lg font-semibold text-gray-700">Incidence Details</h3>
                            <p>
                                <span className="font-medium">Type:</span> {incidence.incidence_type}
                            </p>
                            <p>
                                <span className="font-medium">Description:</span>{" "}
                                {incidence.incidence_description}
                            </p>
                        </div>

                        {/* Reporter Section */}
                        <div className="mb-6">
                            <h3 className="text-lg font-semibold text-gray-700">Reporter</h3>
                            <p>
                                <span className="font-medium">Reported By:</span> {incidence.reported_by}
                            </p>
                            <p>
                                <span className="font-medium">Time:</span>{" "}
                                {new Date(incidence.created_at).toLocaleString()}
                            </p>
                        </div>

                        {/* Status & Priority Section */}
                        <div className="mb-6">
                            <h3 className="text-lg font-semibold text-gray-700">Status & Priority</h3>
                            <p>
                                <span className="font-medium">Status:</span>{" "}
                                <span
                                    className={`px-2 py-1 rounded ${
                                        incidence.status === "resolved"
                                            ? "bg-green-100 text-green-800"
                                            : incidence.status === "under investigation"
                                                ? "bg-yellow-100 text-yellow-800"
                                                : "bg-red-100 text-red-800"
                                    }`}
                                >
                {incidence.status}
              </span>
                            </p>
                            <p>
                                <span className="font-medium">Priority:</span>{" "}
                                <span
                                    className={`px-2 py-1 rounded ${
                                        incidence.priority === "critical"
                                            ? "bg-red-200 text-red-800"
                                            : incidence.priority === "high"
                                                ? "bg-orange-200 text-orange-800"
                                                : incidence.priority === "medium"
                                                    ? "bg-yellow-200 text-yellow-800"
                                                    : "bg-green-200 text-green-800"
                                    }`}
                                >
                {incidence.priority}
              </span>
                            </p>
                        </div>

                        {/* Images Section */}
                        {incidence.images?.length > 0 && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold text-gray-700">Images</h3>
                                <div className="flex gap-4 overflow-x-auto">
                                    {incidence.images.map((url, index) => (
                                        <img
                                            key={index}
                                            src={url}
                                            alt={`Incidence`}
                                            className="w-24 h-24 object-cover rounded border"
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <VideoPlayer src={"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4" } />
        </Drawer>
    );
};
